import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-light p-2 mt-4">
      <p className="text-muted">&copy; 2018 Personal Trainer</p>
    </footer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/modules/core/components/Footer.js